// !! IMPORTANT !!
// document.addEventListener('DOMContentLoaded', function () {}, false); n'est pas nécessaire si attribut defer utilisé pour charger le script

window.body = document.body;

window.toggleClass = function(element, className) {
    element.classList.toggle(className);
};

window.querySelectorAll = function(selector) {
    return Array.from(document.querySelectorAll(selector));
};


// MENU MOBILE
// -----------

const menuToggle = document.querySelector('header.gl-main .gl-btn__mobile');
const menuMobile = document.querySelector('header.gl-main .gl-group');

if (menuToggle && menuMobile) {
    menuToggle.addEventListener('click', function () {
        const isOpen = this.getAttribute('aria-expanded') === 'true';
        const newState = !isOpen;

        this.classList.toggle('open', newState);
        menuMobile.classList.toggle('open', newState);

        this.setAttribute('aria-expanded', String(newState));
        this.setAttribute(
            'aria-label',
            newState ? 'Fermer le menu' : 'Ouvrir le menu'
        );
    });
}



// SEARCH
// ------------

const searchToggle = document.querySelector('header.gl-main .gl-search > button');
const formSearch = document.querySelector('header.gl-main .gl-search > form');

if (searchToggle && formSearch) {
    searchToggle.addEventListener('click', function () {
        const isOpen = this.getAttribute('aria-expanded') === 'true';
        const newState = !isOpen;

        formSearch.classList.toggle('open', newState);

        this.setAttribute('aria-expanded', String(newState));
        this.setAttribute(
            'aria-label',
            newState ? 'Fermer la recherche' : 'Ouvrir la recherche'
        );
    });
}



// DROPDOWN
// ------------

function closeAllDropdowns() {
    querySelectorAll(".gl-pro-access .gl-dropdown.open").forEach(openDropdown => {
        openDropdown.classList.remove("open");
    });
}

querySelectorAll(".gl-pro-access").forEach(el => {
    const langSelector = el.querySelector("span");
    const dropdown = el.querySelector(".gl-dropdown");

    if (!langSelector || !dropdown) return;

    langSelector.addEventListener("click", function (event) {
        event.stopPropagation();
        closeAllDropdowns();
        toggleClass(dropdown, "open");
    });

    document.addEventListener("click", closeAllDropdowns);

    dropdown.addEventListener("click", function (event) {
        if (event.target.tagName === "A") {
            dropdown.classList.remove("open");
        }
    });
});




// CALL TO ACTION BTN - HOVER BEHAVIOR ON MOBILE
document.querySelectorAll('.gl-callback_action, .gl-devis_action').forEach(el => {
    el.addEventListener('touchstart', function(e) {
        if (window.innerWidth > 991) return;

        e.preventDefault();

        if (el.classList.contains('hover')) {
            window.location = el.getAttribute('href');
            el.classList.remove('hover');
        } else {
            el.classList.add('hover');
        }
    });
});






// READMORE
// ------------

document.querySelectorAll(".gl-btn-read-more").forEach((btn, index) => {
    const moreLabel = "Lire plus…";
    const lessLabel = "Lire moins";

    const contentId = `gl-read-more-content-${index + 1}`;

    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", contentId);
    btn.setAttribute("aria-label", "Afficher la suite du contenu");

    if (!btn.textContent.trim()) btn.textContent = moreLabel;

    // Marqueur d'origine
    const origin = document.createElement("span");
    origin.className = "gl-readmore-origin";
    origin.style.display = "none";
    btn.before(origin);

    // 1) Inline: ce qui suit le bouton dans le même p/li...
    const inlineWrap = document.createElement("span");
    inlineWrap.className = "gl-hidden-inline";
    inlineWrap.style.display = "none";
    let n = btn.nextSibling, movedInline = false;
    while (n) {
        const next = n.nextSibling;
        inlineWrap.appendChild(n);
        movedInline = true;
        n = next;
    }
    if (movedInline) btn.insertAdjacentElement("afterend", inlineWrap);

    // 2) Remonter à l’ancêtre "ancre" qui a un frère suivant
    let anchor = btn.parentElement;
    while (anchor && !anchor.nextElementSibling) {
        anchor = anchor.parentElement;
    }

    let hiddenDiv = null;
    let movedBlock = false;

    if (anchor) {
        hiddenDiv = document.createElement("div");
        hiddenDiv.className = "gl-hidden-content";
        hiddenDiv.id = contentId;
        hiddenDiv.style.display = "none";

        let sib = anchor.nextSibling;

        while (sib) {

            // Arrêter le readmore avant l'élément .gl-readmore-end
            if (
                sib.nodeType === Node.ELEMENT_NODE &&
                sib.classList.contains("gl-readmore-end")
            ) {
                break;
            }

            const next = sib.nextSibling;

            hiddenDiv.appendChild(sib);
            movedBlock = true;

            sib = next;
        }

        anchor.insertAdjacentElement("afterend", hiddenDiv);
    }

    // util: retourne le dernier <p> descendant (ou null)
    const findLastP = (container) => {
        const ps = container.querySelectorAll("p");
        return ps.length ? ps[ps.length - 1] : null;
    };

    // 3) Toggle + placement du bouton
    btn.addEventListener("click", () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        const nextState = !expanded;

        if (nextState) {
            // OUVRIR
            if (movedInline) inlineWrap.style.display = "inline";
            if (movedBlock && hiddenDiv) {
                hiddenDiv.style.display = "block";

                // Placer le bouton dans le DERNIER <p> du contenu caché; sinon créer un <p>
                let targetP = findLastP(hiddenDiv);
                if (!targetP) {
                    targetP = document.createElement("p");
                    targetP.className = "gl-readmore-footer";
                    hiddenDiv.appendChild(targetP);
                }
                targetP.appendChild(document.createTextNode(' '));
                targetP.appendChild(btn);
            } else {
                // Pas de bloc : placer à la fin du <p> contenant (après le inlineWrap)
                const parentP = btn.closest("p");
                if (parentP) {
                    parentP.appendChild(document.createTextNode(' '));
                    parentP.appendChild(btn);
                }else{
                    inlineWrap.insertAdjacentElement("afterend", btn); // fallback
                }
            }

            btn.textContent = lessLabel;
        } else {
            // FERMER
            origin.insertAdjacentElement("afterend", btn);
            btn.textContent = moreLabel;

            if (movedInline) inlineWrap.style.display = "none";
            if (movedBlock && hiddenDiv) hiddenDiv.style.display = "none";
        }

        btn.setAttribute("aria-expanded", String(nextState));
        btn.setAttribute(
            "aria-label",
            nextState ? "Masquer la suite du contenu" : "Afficher la suite du contenu"
        );
    });
});










// SMOOTH SCROLL ANCHORS
// ------------

const anchors = document.querySelectorAll('.gpg-linuit a[href^="#"]');
if (anchors.length > 0) {
    anchors.forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetID = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetID);
            if (targetElement) {
                const offset = 180;
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}




// ACCORDION
// ------------

function faqFilter() {
    const faqList = document.querySelector('.faq_list');
    if (!faqList) return;

    const sourceDiv = faqList.querySelector('.accordion_items_sources');
    const sourceItems = sourceDiv.querySelectorAll('.gl-item');
    const col1 = faqList.querySelector('.gl-col1');
    const col2 = faqList.querySelector('.gl-col2');
    const filterButtons = faqList.querySelectorAll('.gl-filters .gl-btn');
    const filterSelect = faqList.querySelector('select');

    function applyFilterAndDispatch(filter) {
        filter = filter.replace('#', '').toLowerCase();
        const filtered = [...sourceItems].filter(item => {
            const itemFilter = item.dataset.filter.toLowerCase();
            return filter === 'all' || itemFilter === filter;
        });
        col1.innerHTML = '';
        col2.innerHTML = '';
        filtered.forEach((item, index) => {
            const clone = item.cloneNode(true);
            prepareAccordionItem(clone, `faq-${index + 1}`);
            if (index % 2 === 0) {
                col1.appendChild(clone);
            } else {
                col2.appendChild(clone);
            }
        });
        col1.style.display = col1.children.length ? '' : 'none';
        col2.style.display = col2.children.length ? '' : 'none';
        rebindAccordionEvents();
    }

    function rebindAccordionEvents() {
        bindAccordionEvents(faqList);
    }

    filterButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            filterButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            const filter = btn.getAttribute('href');
            applyFilterAndDispatch(filter);
            if (filterSelect) {
                filterSelect.value = filter;
            }
        });
    });

    if (filterSelect) {
        filterSelect.addEventListener('change', e => {
            const filter = e.target.value;
            applyFilterAndDispatch(filter);
            filterButtons.forEach(b => {
                const href = b.getAttribute('href');
                b.classList.toggle('active', href === filter);
            });
        });
    }

    sourceDiv.classList.add('hidden');
    applyFilterAndDispatch('all');
}

function prepareAccordionItem(item, uniqueId) {
    const btn = item.querySelector('h3 button, h3 a');
    const panel = item.querySelector('.base');
    if (!btn || !panel) return;
    delete btn.dataset.accordionBound;
    const panelId = `${uniqueId}-panel`;
    panel.id = panelId;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', panelId);
    if (btn.tagName === 'A' && !btn.getAttribute('href')) {
        btn.setAttribute('href', '#');
    }
    if (!panel.hasAttribute('role')) {
        panel.setAttribute('role', 'region');
    }
}

function bindAccordionEvents(container = document) {
    container.querySelectorAll('.gl-accordion .gl-item h3 button, .gl-accordion .gl-item h3 a').forEach(btn => {
        if (btn.dataset.accordionBound === 'true') return;
        btn.dataset.accordionBound = 'true';
        btn.addEventListener('click', function(event) {
            if (btn.tagName === 'A') {
                event.preventDefault();
            }
            const item = btn.closest('.gl-item');
            if (!item) return;
            const panel = item.querySelector('.base');
            if (!panel) return;
            const isOpen = btn.getAttribute('aria-expanded') === 'true';
            const newState = !isOpen;
            item.classList.toggle('active', newState);
            btn.setAttribute('aria-expanded', String(newState));
            if (newState) {
                panel.style.maxHeight = panel.scrollHeight + 'px';
            } else {
                panel.style.maxHeight = null;
            }
        });
    });
}

if (document.querySelector('.gl-accordion')) {
    document.querySelectorAll('.gl-accordion .gl-item').forEach((item, index) => {
        prepareAccordionItem(
            item,
            `accordion-${index + 1}`
        );
    });
    bindAccordionEvents();
    if (document.querySelector('.gl-filters')) {
        faqFilter();
    }
}




// GESTION DES BOUTONS "DEMANDER UN DEVIS"
// ------------

document.addEventListener('click', function (event) {
    const button = event.target.closest('.js-product-quote');

    if (!button) return;

    const url = button.dataset.url;
    const params = new URLSearchParams();

    if (button.dataset.prodTitle) {
        params.set('prod_title', button.dataset.prodTitle);
    }

    if (button.dataset.prodRef) {
        params.set('prod_ref', button.dataset.prodRef);
    }

    if (button.dataset.prodType) {
        params.set('prod_type', button.dataset.prodType);
    }

    window.location.href = `${url}#${params.toString()}`;
});





// GESTION DES BOUTONS "PERSONNALISER" (lien vers le configurateur)
// ------------

document.addEventListener('click', function (event) {
    const button = event.target.closest('.js-open-configurator');

    if (!button) {
        return;
    }

    const configuratorUrl = button.dataset.configuratorUrl;

    if (!configuratorUrl) {
        return;
    }

    window.location.href = configuratorUrl;
});
